var pug = require("!../../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};


















































pug_mixins["checkbox"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
if (!attributes.attributes) {
attributes.attributes = {}
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": "checkbox schema-form-checkbox"},attributes.groupAttributes]), true)) + "\u003E\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes([attributes.fieldHtmlClass], [true]),"type": "checkbox","ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"id": pug.escape(id),"name": pug.escape(id),"required": pug.escape(attributes.required),"ng-true-value": pug.escape(attributes['ng-true-value']),"ng-false-value": pug.escape(attributes['ng-false-value']),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E\u003Clabel" + (pug.attr("class", pug.classes([attributes.labelHtmlClass], [true]), false, true)+pug.attr("for", id, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E";
};




















































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"checkout-wrapper\"\u003E\u003Ca class=\"back-link\" ng-click=\"$bonagoCheckoutCtrl.navigateToHome()\"\u003E\u003Ci class=\"font-icon icon-left\"\u003E\u003C\u002Fi\u003E Zurück \u003C\u002Fa\u003E\u003Cdiv class=\"checkout-main\"\u003E\u003Cdiv class=\"checkout_zusammenfassung-wrapper\" overlay=\"$bonagoCheckoutCtrl.loading.main\"\u003E\u003Cdiv class=\"bigbox centered\"\u003E\u003Cdiv class=\"header\"\u003E\u003Cspan\u003EIhr Vorteilskonto Warenkorb\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\"\u003E\u003Cdiv class=\"mainWrapper\"\u003E\u003Ch3\u003EAktuell befinden sich folgende Gutscheine in Ihrem Warenkorb:\u003C\u002Fh3\u003E\u003Cdiv class=\"margin-top-big\"\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"!$bonagoCheckoutCtrl.hasVouchers()\"\u003E \u003Cdiv class=\"columns small-12\"\u003EEs wurden noch keine Gutscheine gewählt\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-if=\"$bonagoCheckoutCtrl.hasVouchers()\"\u003E\u003Cdiv class=\"column small-12\"\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-7\"\u003E&nbsp;\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3 center\"\u003EBetrag\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 center\"\u003EGesamt\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\" ng-repeat=\"(voucher_id, voucher) in $bonagoCheckoutCtrl.basket.getItems()\"\u003E\u003Cdiv class=\"columns medium-7\"\u003E{{voucher.quantity }} x {{ voucher.retailer_name }} \u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3 center\"\u003E{{ voucher.price | currency }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 center\"\u003E{{ voucher.value | currency }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns medium-10\"\u003EAbruf Gesamt\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 center\"\u003E{{ $bonagoCheckoutCtrl.getBasketSum() | currency }}\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cp\u003EUm die aufgelisteten Gutscheine nun abschließend zu bestellen, akzeptieren Sie die Einlösebedingungen und klicken Sie auf \"Gutscheine abrufen\".\u003C\u002Fp\u003E\u003Cp\u003EMit diesem Vorgang wird Ihr aktuelles Guthaben von {{ $bonagoCheckoutCtrl.getBalance() | currency }} mit {{ $bonagoCheckoutCtrl.getBasketSum() | currency }} belastet.\u003C\u002Fp\u003E\u003Cp\u003ENach dem Abruf beträgt das verbleibendes Guthaben noch {{ $bonagoCheckoutCtrl.getRest() | currency }}.\u003C\u002Fp\u003E\u003Cp\u003EJe nach Gutscheinart erhalten Sie die bestellten Gutscheine per E-Mail oder postalisch.\u003C\u002Fp\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cdiv\u003EBitte prüfen Sie die Angaben und nehmen ggf. Anpassungen vor. Änderungen hier werden nicht gespeichert und sind nur einmalig für die Gutscheinbestellung relevant.\u003C\u002Fdiv\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "$bonagoCheckoutCtrl.delivery_information.email","title": "E-Mail Adresse","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie eine E-Mail Adresse an"}}
});
pug_mixins["input"].call({
attributes: {"key": "$bonagoCheckoutCtrl.delivery_information.strasse","title": "Straße","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie eine Straße an"}}
});
pug_mixins["input"].call({
attributes: {"key": "$bonagoCheckoutCtrl.delivery_information.plz","title": "PLZ","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie eine Postleitzahl an"}}
});
pug_mixins["input"].call({
attributes: {"key": "$bonagoCheckoutCtrl.delivery_information.ort","title": "Stadt","required": pug.escape(true),"validationMessages": {"required":"Bitte geben Sie eine Stadt an"}}
});
},
attributes: {"name": "$bonagoCheckoutCtrl.forms.delivery_information"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-2\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["checkbox"].call({
attributes: {"id": "bonagoToc","key": "$bonagoCheckoutCtrl.models.read_toc","data-cy": "benefit.bonago.checkout.basketOverview.checkTerms","required": pug.escape(true),"attributes": {"ng-change":"$bonagoCheckoutCtrl.handleTocChange()"}}
});
},
attributes: {"name": "$bonagoCheckoutCtrl.forms.tocForm"}
});
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns large-6\"\u003E\u003Clabel for=\"bonagoToc\"\u003EHiermit stimme ich den Einlösebedingungen zu.\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns\" overlay=\"$bonagoCheckoutCtrl.loading.checkout\"\u003E\u003Cbutton class=\"btn btn-primary left\" ng-click=\"$bonagoCheckoutCtrl.cancelCheckout()\" data-cy=\"data-cy=&quot;benefit.bonago.checkout.summary.buttonCancel\"\u003EAbbrechen\u003C\u002Fbutton\u003E\u003Cbutton class=\"btn btn-primary right\" ng-disabled=\"!$bonagoCheckoutCtrl.canFinishCheckout()\" ng-click=\"$bonagoCheckoutCtrl.completeCheckout()\" data-cy=\"benefit.bonago.checkout.summary.buttonFinishCheckout\"\u003EGutscheine abrufen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;